import { LogicalAndFilter } from '@cubejs-client/core';

export const extractFilterFromGlobalFilters = ({
  filterToExclude,
  globalFilters,
}: {
  globalFilters: LogicalAndFilter;
  filterToExclude: string;
}) =>
  globalFilters.and.filter(item => {
    if (!Object.values(item).includes(filterToExclude)) {
      return item;
    }
  });
